import { AxiosPromise } from 'axios';
import VideoDetectionPlacement from 'Models/Videos/VideoDetectionPlacement';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

const postVideoDetectionPlacement = (
	token: string | null,
	placement: Omit<VideoDetectionPlacement, 'id' | 'visuaId'>
): AxiosPromise<VideoDetectionPlacement> => {
	const url = getApiUrl(ApiUrl.Placements);
	const axiosInstance = getAxiosInstance(token);
	return axiosInstance.post(url, placement);
};

export default postVideoDetectionPlacement;
